/* eslint-disable no-unused-vars */
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

// import { useEffect, useMemo } from "react";
// eslint-disable-next-line import/no-cycle
import CustomEditor from "./CustomEditor";
import CustomTextField from "./CustomTextField";
import CustomSelect from "./CustomSelect";
import CustomSwitch from "./CustomSwitch";
import CustomAutocomplete from "./CustomAutocomplete";
import CustomAutocompleteAsync from "./CustomAutocompleteAsync";
import CustomCheckbox from "./CustomCheckbox";
import CustomDecimal from "./CustomDecimal";
import CustomMultiSelect from "./CustomMultiSelect";
import CustomSlider from "./CustomSlider";
import CustomIconPicker from "./CustomIconPicker";
import CustomDateRange from "./CustomDateRange";
import CustomDateTimePicker from "./CustomDateTimePicker";
import CustomDatePicker from "./CustomDatePicker";
import CustomTimePicker from "./CustomTimePicker";

export default function InputSwitch(props) {
    const {
        type,
        disabled,
        formDisabled,
        required,
        fullWidth,
        fullHeight,
        neededWidth, // only select, for TextField + Select inside flex line
        options, // only select, autocomplete
        optionsFilter, // autocomplete-async
        getOptions, // autocomplete-async
        getSelectedOption, // autocomplete-async
        optionsKey, // only select, autocomplete(-async)
        optionsName, // only select, autocomplete(-async)
        optionsFormat, // only select, autocomplete(-async)
        labelFormat, // only select, autocomplete(-async)
        optionsValueType = "object", // only select, autocomplete(-async): "object" or "key"
        falseLabel, // only switch
        trueLabel, // only switch
        falseValueColor, // only switch
        trueValueColor, // only switch
        checked, // only switch, checkbox
        align = "left", // only switch
        labelPlacement, // only checkbox
        disableOption,
        label,
        name,
        placeholder,
        value = "",
        onChange: onChangePassThrough,
        onBlurForm,
        onClick,
        onKeyDown,
        onInputChange, // autocomplete
        blurOnSelect, // autocomplete
        startAdornment,
        endAdornment,
        sx,
        className,
        children,
        multiline,
        rows,
        inputProps,
        pattern,
        filterDisabled,
        filterData,
        filterOptions,
        addOption,
        disableClearable,
        validate,
        allowShowPassword,
        allowGeneratePassword,
        customGeneratePasswordFunction,
        isLoading,
        maxHeight,
        autoFocus,
        allowCopy,
        clearField,
        menuItemStyle,
        icon,
        checkedIcon,
        color,
        freeSolo,
        allowEmpty,
        dateParseTemplate,
        allowNegative, // decimal
        thousandSeparator, // decimal
        decimalSeparator, // decimal
        decimalScale, // decimal
        fixedDecimalScale, // decimal
        inputLink,
        onClear,
        maxValue, // slider
        minValue, // slider
        marks, // slider
        valueLabelDisplay, // slider
        valueLabelFormat, // slider
        step, // slider
        maxDateTime, // datetimepicker
        minDateTime, // datetimepicker
        onError,
        inputStyle,
        tabId, // for Boilerplates Dialog in CustomEditor
        disableEmptySelection,
        onContextMenu,
        forcedRootBlock,
    } = props;

    const { control } = useFormContext();

    // return (
    //     <Controller
    //         control={control}
    //         name={name}
    //         defaultValue={value}
    //         shouldUnregister
    //         render={({
    //             field,
    //             fieldState,
    //         }) => (
    //             <Switch field={field} fieldState={fieldState} />
    //         )}
    //         rules={{
    //             required,
    //         }}
    //     />
    // );
    switch (type) {
    case "checkbox":
        return (
            <Controller
                control={control}
                name={name}
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value: checked, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomCheckbox
                        label={label}
                        labelPlacement={labelPlacement || "end"}
                        className={className}
                        disabled={disabled || formDisabled}
                        required={required}
                        checked={typeof value === "boolean" ? (value ?? "") : (checked ?? false)}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e.target.checked);
                            onChangeForm(e.target.checked);
                        }}
                        inputRef={ref}
                        // error={fieldState.invalid}
                        name={name}
                        isLoading={isLoading}
                        sx={sx}
                        icon={icon}
                        checkedIcon={checkedIcon}
                        color={color}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "editor":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                    // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomEditor
                        label={label}
                        disabled={disabled || formDisabled}
                        className={className}
                        required={required}
                        onChange={(onChangeValue) => {
                            if (onChangePassThrough) onChangePassThrough(onChangeValue);
                            onChangeForm(onChangeValue);
                        }}
                        onBlur={onBlur}
                        name={name}
                        value={value}
                        inputRef={ref}
                        error={fieldState.invalid}
                        fullHeight={fullHeight}
                        fullWidth={fullWidth}
                        isLoading={isLoading}
                        tabId={tabId}
                        sx={sx}
                        forcedRootBlock={forcedRootBlock}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "icon":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                    // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomIconPicker
                        label={label}
                        disabled={disabled || formDisabled}
                        className={className}
                        required={required}
                        onChange={(onChangeValue) => {
                            if (onChangePassThrough) onChangePassThrough(onChangeValue);
                            onChangeForm(onChangeValue);
                        }}
                        onBlur={onBlur}
                        name={name}
                        value={value}
                        inputRef={ref}
                        error={fieldState.invalid}
                        isLoading={isLoading}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "autocomplete-async":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomAutocompleteAsync
                        fullWidth={fullWidth}
                        disabled={disabled || formDisabled}
                        className={className}
                        required={required}
                        label={label}
                        onInputChange={onInputChange}
                        blurOnSelect={blurOnSelect}
                        optionsFilter={optionsFilter}
                        getOptions={getOptions}
                        getSelectedOption={getSelectedOption}
                        optionsKey={optionsKey}
                        optionsValueType={optionsValueType}
                        optionsName={optionsName}
                        optionsFormat={optionsFormat}
                        labelFormat={labelFormat}
                        sx={sx}
                        onChange={(onChangeValue, onChangeValue2) => {
                            if (onChangePassThrough) onChangePassThrough(onChangeValue, onChangeValue2);
                            onChangeForm(onChangeValue);
                        }}
                        onBlur={onBlur}
                        name={name}
                        value={value}
                        inputRef={ref}
                        error={fieldState.invalid}
                        onClick={onClick}
                        isLoading={isLoading}
                        autoFocus={autoFocus}
                        freeSolo={freeSolo}
                        filterDisabled={filterDisabled}
                        placeholder={placeholder}
                        onClear={onClear}
                        onKeyDown={onKeyDown}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "autocomplete":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomAutocomplete
                        fullWidth={fullWidth}
                        className={className}
                        disabled={disabled || formDisabled}
                        required={required}
                        label={label}
                        onInputChange={onInputChange}
                        blurOnSelect={blurOnSelect}
                        optionsFilter={optionsFilter}
                        options={options}
                        getSelectedOption={getSelectedOption}
                        optionsKey={optionsKey}
                        optionsValueType={optionsValueType}
                        optionsName={optionsName}
                        optionsFormat={optionsFormat}
                        labelFormat={labelFormat}
                        sx={sx}
                        onChange={(onChangeValue, onChangeValue2) => {
                            if (onChangePassThrough) onChangePassThrough(onChangeValue, onChangeValue2);
                            onChangeForm(onChangeValue);
                        }}
                        onBlur={onBlur}
                        name={name}
                        value={value}
                        inputRef={ref}
                        error={fieldState.invalid}
                        filterData={filterData}
                        filterDisabled={filterDisabled}
                        addOption={addOption}
                        disableClearable={disableClearable}
                        isLoading={isLoading}
                        freeSolo={freeSolo}
                        startAdornment={startAdornment}
                        endAdornment={endAdornment}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "switch":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={checked}
                // shouldUnregister
                render={({
                    field: {
                    // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value: checked, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomSwitch
                        fullWidth={fullWidth}
                        disabled={disabled || formDisabled}
                        className={className}
                        label={label}
                        checked={checked || false}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e.target.checked);
                            onChangeForm(e.target.checked);
                        }}
                        falseLabel={falseLabel}
                        trueLabel={trueLabel}
                        icon={icon}
                        checkedIcon={checkedIcon}
                        falseColor={falseValueColor}
                        trueColor={trueValueColor}
                        align={align}
                        sx={sx}
                        onBlur={onBlur}
                        name={name}
                        value={value}
                        inputRef={ref}
                        // error={fieldState.invalid}
                        isLoading={isLoading}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "select":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomSelect
                        fullWidth={fullWidth}
                        className={className}
                        neededWidth={neededWidth}
                        disabled={disabled || formDisabled}
                        required={required}
                        label={label}
                        options={options}
                        optionsKey={optionsKey}
                        optionsValueType={optionsValueType}
                        placeholder={placeholder}
                        optionsName={optionsName}
                        optionsFormat={optionsFormat}
                        labelFormat={labelFormat}
                        sx={sx}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e.target.value || null);
                            onChangeForm(e.target.value || null);
                        }}
                        onBlur={onBlurForm}
                        name={name}
                        value={value || ""}
                        inputRef={ref}
                        error={fieldState.invalid}
                        filterDisabled={filterDisabled}
                        filterData={filterData}
                        filterOptions={filterOptions}
                        onClick={onClick}
                        isLoading={isLoading}
                        maxHeight={maxHeight}
                        menuItemStyle={menuItemStyle}
                    >
                        {children}
                    </CustomSelect>
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "multiselect":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomMultiSelect
                        fullWidth={fullWidth}
                        className={className}
                        neededWidth={neededWidth}
                        disabled={disabled || formDisabled}
                        required={required}
                        label={label}
                        options={options}
                        optionsKey={optionsKey}
                        optionsValueType={optionsValueType}
                        placeholder={placeholder}
                        optionsName={optionsName}
                        optionsFormat={optionsFormat}
                        labelFormat={labelFormat}
                        sx={sx}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e || []);
                            onChangeForm(e || []);
                        }}
                        onBlur={onBlurForm}
                        name={name}
                        value={value || ""}
                        inputRef={ref}
                        error={fieldState.invalid}
                        filterDisabled={filterDisabled}
                        filterData={filterData}
                        onClick={onClick}
                        isLoading={isLoading}
                        maxHeight={maxHeight}
                        menuItemStyle={menuItemStyle}
                        disableEmptySelection={disableEmptySelection}
                    >
                        {children}
                    </CustomMultiSelect>
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "slider":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomSlider
                        label={label}
                        value={value || [0, 0]}
                        name={name}
                        onChange={(e) => onChangeForm(e)}
                        disabled={disabled}
                        maxValue={maxValue}
                        minValue={minValue}
                        marks={marks}
                        step={step}
                        valueLabelDisplay={valueLabelDisplay}
                        valueLabelFormat={valueLabelFormat}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "decimal":
        return (
            <Controller
                control={control}
                name={name}
                valueAsNumber={type === "number"}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomDecimal
                        variant="outlined"
                        fullWidth={fullWidth}
                        className={className}
                        disabled={disabled || formDisabled}
                        required={required}
                        label={label}
                        placeholder={placeholder}
                        type={type}
                        startAdornment={startAdornment}
                        endAdornment={endAdornment}
                        sx={sx}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e.floatValue);
                            onChangeForm(e.floatValue);
                        }}
                        onBlur={onBlurForm}
                        onClick={onClick}
                        name={name}
                        value={value || ""}
                        inputRef={ref}
                        error={fieldState.invalid}
                        multiline={multiline}
                        rows={rows}
                        inputProps={inputProps}
                        allowShowPassword={allowShowPassword}
                        allowGeneratePassword={allowGeneratePassword}
                        isLoading={isLoading}
                        autoFocus={autoFocus}
                        allowCopy={allowCopy}
                        clearField={clearField}
                        allowEmpty={allowEmpty}
                        allowNegative={allowNegative}
                        thousandSeparator={thousandSeparator}
                        decimalSeparator={decimalSeparator}
                        decimalScale={decimalScale}
                        fixedDecimalScale={fixedDecimalScale}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: (val) => {
                        // const validations = {};

                        if (validate) {
                            return validate(val);
                        }

                        if (!allowEmpty && type === "number") {
                            return !Number.isNaN(val);
                        }

                        return true;
                    },
                }}
            />
        );
    case "daterange":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomDateRange
                        label={label}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />

        );
    case "datetimepicker":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomDateTimePicker
                        fullWidth={fullWidth}
                        name={name}
                        label={label}
                        required={required}
                        disabled={disabled}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e);
                            onChangeForm(e);
                        }}
                        value={value}
                        maxDateTime={maxDateTime}
                        minDateTime={minDateTime}
                        onError={onError}
                        inputProps={inputProps}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "timepicker":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomTimePicker
                        {...props}
                        name={name}
                        label={label}
                        required={required}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e);
                            onChangeForm(e);
                        }}
                        value={value}
                        maxDateTime={maxDateTime}
                        minDateTime={minDateTime}
                        onError={onError}
                        inputProps={inputProps}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    case "datepicker":
        return (
            <Controller
                control={control}
                name={name}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomDatePicker
                        {...props}
                        name={name}
                        label={label}
                        required={required}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e);
                            onChangeForm(e);
                        }}
                        value={value}
                        maxDateTime={maxDateTime}
                        minDateTime={minDateTime}
                        onError={onError}
                        inputProps={inputProps}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: validate && ((val) => validate(val)),
                }}
            />
        );
    default:
        return (
            <Controller
                control={control}
                name={name}
                valueAsNumber={type === "number"}
                // defaultValue={value}
                // shouldUnregister
                render={({
                    field: {
                        // eslint-disable-next-line no-shadow
                        onChange: onChangeForm, onBlur, value, name, ref,
                    },
                    fieldState,
                }) => (
                    <CustomTextField
                        variant="outlined"
                        fullWidth={fullWidth}
                        className={className}
                        disabled={disabled || formDisabled}
                        required={required}
                        label={label}
                        placeholder={placeholder}
                        type={type}
                        startAdornment={startAdornment}
                        endAdornment={endAdornment}
                        sx={sx}
                        onChange={(e) => {
                            if (onChangePassThrough) onChangePassThrough(e.target.value);
                            onChangeForm(type === "number" ? parseFloat(e.target.value) : e.target.value);
                        }}
                        onBlur={onBlurForm}
                        onClick={onClick}
                        onKeyDown={onKeyDown}
                        name={name}
                        value={value || (type === "number" && value === 0 ? 0 : "")}
                        inputRef={ref}
                        error={fieldState.invalid}
                        multiline={multiline}
                        rows={rows}
                        inputProps={inputProps}
                        allowShowPassword={allowShowPassword}
                        allowGeneratePassword={allowGeneratePassword}
                        customGeneratePasswordFunction={customGeneratePasswordFunction}
                        isLoading={isLoading}
                        autoFocus={autoFocus}
                        allowCopy={allowCopy}
                        clearField={clearField}
                        allowEmpty={allowEmpty}
                        inputLink={inputLink}
                        dateParseTemplate={dateParseTemplate}
                        step={step}
                        inputStyle={inputStyle}
                        onContextMenu={onContextMenu}
                    />
                )}
                rules={{
                    required,
                    pattern,
                    validate: (val) => {
                        // const validations = {};

                        if (validate) {
                            return validate(val);
                        }

                        if (!allowEmpty && type === "number") {
                            return !Number.isNaN(val);
                        }

                        return true;
                    },
                }}
            />
        );
    }
}
